import { createSelector } from 'reselect'
import { selectActivityTypes } from 'services/activityTypes/selectors'

export const selectUserStats = (state) => state.userStats

export const selectStats = createSelector(
  selectUserStats,
  (userStats) => userStats && userStats.stats,
)

export const selectSummaryStats = createSelector(
  selectUserStats,
  (userStats) => userStats && userStats.summary_stats && (userStats.summary_stats[0] || []),
)

export const selectStatsWithActivityNames = createSelector(
  selectStats,
  selectActivityTypes,
  (stats, activityTypes) => {
    if (!stats || !activityTypes) { return }
    return stats.map((stat) => {
      const activityTypeId = stat._links.activity_type[0].id
      const activityType = activityTypes.find((activity) => activityTypeId === activity._links.root[0].id)
      stat.activity_name = activityType ? activityType.name : 'Other'
      return stat
    })
  }
)
